// Trainer setup controls and clocks for standard chess and pawns mode.
import type { Color, RoomState } from '../../types';

type TrainerGamePanelProps = {
  state: RoomState | null;
  gameMinutes: number;
  gameIncrement: number;
  trainerColor: Color;
  startingTurn: Color;
  onGameMinutesChange: (minutes: number) => void;
  onGameIncrementChange: (seconds: number) => void;
  onTrainerColorChange: (color: Color) => void;
  onStartingTurnChange: (color: Color) => void;
  onStartGame: () => void;
  onUndo: () => void;
  onFinishStandardGame: () => void;
  onFinishPawnsGame: () => void;
};

export function TrainerGamePanel({
  state,
  gameMinutes,
  gameIncrement,
  trainerColor,
  startingTurn,
  onGameMinutesChange,
  onGameIncrementChange,
  onTrainerColorChange,
  onStartingTurnChange,
  onStartGame,
  onUndo,
  onFinishStandardGame,
  onFinishPawnsGame
}: TrainerGamePanelProps) {
  const active = state?.gameTimer.active;

  return (
    <section className="panel">
      <h2>Партия</h2>
      <div className="grid-2">
        <div>
          <label htmlFor="game-minutes">Минуты</label>
          <input id="game-minutes" type="number" min={0} disabled={active} value={gameMinutes} onChange={(event) => onGameMinutesChange(Number(event.target.value))} />
        </div>
        <div>
          <label htmlFor="game-increment">Инкремент</label>
          <input id="game-increment" type="number" min={0} disabled={active} value={gameIncrement} onChange={(event) => onGameIncrementChange(Number(event.target.value))} />
        </div>
      </div>
      <div className="section-label">Тренер играет за</div>
      <div className="inline">
        <button className={trainerColor === 'w' ? 'primary' : 'secondary'} disabled={active} onClick={() => onTrainerColorChange('w')}>Белые</button>
        <button className={trainerColor === 'b' ? 'primary' : 'secondary'} disabled={active} onClick={() => onTrainerColorChange('b')}>Чёрные</button>
      </div>
      {state?.mode === 'standard' && (
        <>
          <div className="section-label">Первый ход</div>
          <div className="inline">
            <button aria-label="Первым ходят белые" className={startingTurn === 'w' ? 'primary' : 'secondary'} disabled={active} onClick={() => onStartingTurnChange('w')}>Белые</button>
            <button aria-label="Первым ходят чёрные" className={startingTurn === 'b' ? 'primary' : 'secondary'} disabled={active} onClick={() => onStartingTurnChange('b')}>Чёрные</button>
          </div>
        </>
      )}
      <button className="success full" disabled={active} onClick={onStartGame}>
        {active ? 'Партия идёт' : 'Начать игру'}
      </button>
      {state?.mode === 'standard' && active && (state.history?.length || 0) > 0 && (
        <button className="primary full" onClick={onUndo}>Отменить ход</button>
      )}
      {state?.mode === 'standard' && active && (
        <button className="danger full" onClick={onFinishStandardGame}>Завершить партию</button>
      )}
      {state?.mode === 'pawns' && active && (
        <button className="danger full" onClick={onFinishPawnsGame}>Завершить партию</button>
      )}
    </section>
  );
}

type GameClockRowProps = {
  whiteClock: string;
  blackClock: string;
};

export function GameClockRow({ whiteClock, blackClock }: GameClockRowProps) {
  return (
    <div className="clock-row">
      <div className="clock white-clock"><small>БЕЛЫЕ</small><strong>{whiteClock}</strong></div>
      <div className="clock black-clock"><small>ЧЁРНЫЕ</small><strong>{blackClock}</strong></div>
    </div>
  );
}
